export default {
  ourLetter: "Nuestra carta",
  restaurantIsClosed: "Restaurante se encuentra cerrado",
  isANewProduct: "Es un producto nuevo",
  isVegetarian: "Es vegetariano",
  containsLupin: "Contiene altramuces",
  containsCelery: "Contiene apio",
  containsPeanuts: "Contiene cacahuetes",
  containsCrustacean: "Contiene crustáceos",
  containsGluten: "Contiene gluten",
  containsEgg: "Contiene huevo",
  containsMilk: "Contiene leche",
  containsMustard: "Contiene mostaza",
  containsFish: "Contiene pescado",
  containsSesame: "Contiene sésamo",
  containsSoy: "Contiene soja",
  containsSulfite: "Contiene sulfito",
  vegetarian: "Vegetariano",
  allergens: "ALÉRGENOS:",
  lupins: "Altramuces",
  celery: "Apio",
  peanuts: "Cacahuetes",
  crustaceans: "Crustáceos",
  gluten: "Gluten",
  egg: "Huevo",
  dairyProducts: "Lacteos",
  mustard: "Mostaza",
  fish: "Pescado",
  sesame: "Sesamo",
  soy: "soja",
  sulfite: "sulfito",
  findProduct: "Buscar producto"
};
